<template>
	<div
		class="spinner"
		:class="`spinner--size-${size} spinner--color-${color}`"
	>
		<div />

		<div />

		<div />
	</div>
</template>

<script>
export default {
	name: 'Spinner',

	props: {
		color: {
			type: String,
			required: false,
			default: 'blue',
			description: 'Sets the color of the spinner',
		},

		size: {
			type: String,
			required: false,
			default: 'normal',
			description: 'Sets the size of the spinner',
		},
	},
};
</script>

<style lang="scss" scoped src="./spinner.scss" />
